var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "margin-negativo" },
    [
      _c(
        "el-row",
        { staticClass: "padding cards-sicarf" },
        [
          _c(
            "el-col",
            {
              staticClass: "margin-bottom-container",
              attrs: { md: 8, sm: 24 }
            },
            [
              _c(
                "div",
                {
                  class: _vm.isIcmBio
                    ? "coluna-externa-icmbio"
                    : "coluna-externa"
                },
                [
                  _c("div", { staticClass: "coluna-interna" }, [
                    _c("div", { staticClass: "quadrante-1" }, [
                      _c("img", {
                        staticClass: "como-fazer-seu-cadastro",
                        style: {
                          height: _vm.isIcmBio ? "120px" : "",
                          width: _vm.isIcmBio ? "auto" : "5.5em"
                        },
                        attrs: {
                          src: require(_vm.isIcmBio
                            ? "@/assets/images/logo-icmBio2.png"
                            : "@/assets/icons/Cadastro.png")
                        }
                      }),
                      _c("h1", { staticClass: "primeiro-titulo-preto" }, [
                        _vm._v(_vm._s(_vm.HOME_PAGE.TITULO_CADASTRO))
                      ])
                    ]),
                    _c("div", {
                      staticClass: "quadrante-2 padding-top-tipo-cadastro",
                      style: {
                        "border-bottom": !_vm.HOME_PAGE.EXIBIR_APTIDAO
                          ? "none"
                          : "1.8px dashed #009d64"
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.HOME_PAGE.TEXTO_CADASTRO)
                      },
                      on: { click: _vm.handleTextoCadastro }
                    }),
                    _vm.HOME_PAGE.EXIBIR_APTIDAO
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "quadrante-3 padding-top-link-baixar-enviar"
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://sicarf.amapaterras.ap.gov.br/documentos-estatico/AUTO_DECLARACAO_DE_APTIDAO_A_REGULARIZACAO_FUNDIARIA.pdf"
                                }
                              },
                              [
                                _c(
                                  "el-span",
                                  { staticClass: "links botao-aptidao" },
                                  [
                                    _c("span", [_vm._v("APTIDÃO")]),
                                    _c("font-awesome-icon", {
                                      staticClass: "icone-colunas",
                                      attrs: { icon: "cloud-download-alt" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.HOME_PAGE.EXIBIR_APTIDAO
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "quadrante-4 padding-top-link-baixar-enviar"
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://sicarf.amapaterras.ap.gov.br/documentos-estatico/DECLARACAO_DE_RESIDENCIA_AP.pdf"
                                }
                              },
                              [
                                _c(
                                  "el-span",
                                  { staticClass: "links botao-aptidao" },
                                  [
                                    _c("span", [_vm._v("RESIDÊNCIA")]),
                                    _c("font-awesome-icon", {
                                      staticClass: "icone-colunas",
                                      attrs: { icon: "cloud-download-alt" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ]
          ),
          _c(
            "el-col",
            {
              staticClass: "margin-bottom-container",
              attrs: { md: 8, sm: 24 }
            },
            [
              _c(
                "div",
                {
                  class: _vm.isIcmBio
                    ? "coluna-externa-icmbio"
                    : "coluna-externa"
                },
                [
                  _c("div", { staticClass: "coluna-interna" }, [
                    _c("div", { staticClass: "quadrante-1" }, [
                      _c("img", {
                        staticClass: "como-fazer-seu-cadastro",
                        style: {
                          height: _vm.isIcmBio ? "120px" : "",
                          width: _vm.isIcmBio ? "auto" : "5.5em"
                        },
                        attrs: {
                          src: require(_vm.isIcmBio
                            ? "@/assets/images/planta-icmBio.png"
                            : "@/assets/icons/OFF.png")
                        }
                      }),
                      _c(
                        "h1",
                        {
                          staticClass:
                            "primeiro-titulo-segunda-coluna primeiro-titulo-preto"
                        },
                        [_vm._v(_vm._s(_vm.HOME_PAGE.TITULO_CADASTRO_OFF))]
                      ),
                      _vm.HOME_PAGE.SUBTITULO_CADASTRO_OFF
                        ? _c(
                            "h1",
                            { staticClass: "segundo-titulo-segunda-coluna" },
                            [
                              _vm._v(
                                _vm._s(_vm.HOME_PAGE.SUBTITULO_CADASTRO_OFF)
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "quadrante-2 padding-top-tipo-cadastro",
                        style: {
                          "border-bottom":
                            !_vm.EXIBIR_COMO_BAIXAR && !_vm.EXIBIR_COMO_ENVIAR
                              ? "none"
                              : "1.8px dashed #009d64"
                        }
                      },
                      _vm._l(_vm.HOME_PAGE.CADASTROS_OFFLINE, function(
                        cadastros
                      ) {
                        return _c("div", [
                          !cadastros.NEED_BREAK
                            ? _c(
                                "div",
                                [
                                  cadastros.TOLLTIP
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: cadastros.TOLLTIP,
                                            placement: "bottom"
                                          }
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(cadastros.SPAN)
                                            }
                                          })
                                        ]
                                      )
                                    : cadastros.SPAN
                                    ? _c("p", {
                                        staticClass: "line-height",
                                        domProps: {
                                          innerHTML: _vm._s(cadastros.SPAN)
                                        }
                                      })
                                    : _vm._e(),
                                  cadastros.TEXTO
                                    ? _c("p", {
                                        staticClass: "item-tipo-cadastro",
                                        domProps: {
                                          innerHTML: _vm._s(cadastros.TEXTO)
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          cadastros.NEED_BREAK
                            ? _c(
                                "div",
                                [
                                  cadastros.TOLLTIP
                                    ? _c("el-tooltip", [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(cadastros.TOLLTIP_PART_1)
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(cadastros.TOLLTIP_PART_2)
                                            )
                                          ]
                                        ),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(cadastros.SPAN)
                                          }
                                        })
                                      ])
                                    : cadastros.SPAN
                                    ? _c("p", {
                                        staticClass: "line-height",
                                        domProps: {
                                          innerHTML: _vm._s(cadastros.SPAN)
                                        }
                                      })
                                    : _vm._e(),
                                  cadastros.TEXTO
                                    ? _c("p", {
                                        staticClass: "item-tipo-cadastro",
                                        domProps: {
                                          innerHTML: _vm._s(cadastros.TEXTO)
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      }),
                      0
                    ),
                    _vm.EXIBIR_COMO_BAIXAR
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "quadrante-3 padding-top-link-baixar-enviar"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "links",
                                attrs: { href: "#/publico/baixar" }
                              },
                              [
                                _c("span", [_vm._v("BAIXAR")]),
                                _c("font-awesome-icon", {
                                  staticClass: "icone-colunas",
                                  attrs: { icon: "cloud-download-alt" }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.EXIBIR_COMO_ENVIAR
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "quadrante-4 padding-top-link-baixar-enviar"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "links",
                                attrs: { href: "#/publico/enviar" }
                              },
                              [
                                _c("span", [_vm._v("ENVIAR")]),
                                _c("font-awesome-icon", {
                                  staticClass: "icone-colunas",
                                  attrs: { icon: "cloud-upload-alt" }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ]
          ),
          _vm.EXIBIR_CADASTRO_ONLINE
            ? _c(
                "el-col",
                {
                  staticClass: "margin-bottom-container",
                  attrs: { md: 8, sm: 24 }
                },
                [
                  _c(
                    "div",
                    {
                      class: _vm.isIcmBio
                        ? "coluna-externa-icmbio"
                        : "coluna-externa"
                    },
                    [
                      _c("div", { staticClass: "coluna-interna" }, [
                        _c("div", { staticClass: "quadrante-1" }, [
                          _c("img", {
                            staticClass: "como-fazer-seu-cadastro",
                            style: {
                              height: _vm.isIcmBio ? "120px" : "",
                              width: _vm.isIcmBio ? "auto" : "5.5em"
                            },
                            attrs: {
                              src: require(_vm.isIcmBio
                                ? "@/assets/images/logo2.png"
                                : "@/assets/icons/ON.png")
                            }
                          }),
                          _c(
                            "h1",
                            {
                              staticClass:
                                "primeiro-titulo-segunda-coluna primeiro-titulo-preto"
                            },
                            [_vm._v(_vm._s(_vm.HOME_PAGE.TITULO_CADASTRO_ON))]
                          ),
                          _vm.HOME_PAGE.SUBTITULO_CADASTRO_ON
                            ? _c(
                                "h1",
                                {
                                  staticClass: "segundo-titulo-segunda-coluna"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.HOME_PAGE.SUBTITULO_CADASTRO_ON)
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "quadrante-5 padding-top-tipo-cadastro",
                            style: {
                              "border-bottom": !_vm.EXIBIR_ACESSAR_ONLINE
                                ? "none"
                                : "1.8px dashed #009d64"
                            }
                          },
                          _vm._l(_vm.HOME_PAGE.CADASTROS_ONLINE, function(
                            cadastros
                          ) {
                            return _c(
                              "div",
                              [
                                cadastros.TOLLTIP
                                  ? _c("el-tooltip", {
                                      attrs: {
                                        content: cadastros.TOLLTIP,
                                        placement: "bottom"
                                      }
                                    })
                                  : _vm._e(),
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(cadastros.SPAN)
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm.EXIBIR_ACESSAR_ONLINE
                          ? _c(
                              "div",
                              { staticClass: "padding-top-link-acesse" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: { href: "#/publico/central" }
                                  },
                                  [
                                    _c("span", [_vm._v("ACESSE")]),
                                    _c("font-awesome-icon", {
                                      staticClass: "icone-colunas",
                                      attrs: { icon: "external-link-alt" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "sicarf" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { md: 24, sm: 24 } }, [
                _c("div", { staticClass: "text-sicarf" }, [
                  _c("div", { staticClass: "cabecalho" }, [
                    _c("h1", { staticClass: "titulo-sicarf" }, [
                      _vm._v(_vm._s(_vm.HOME_PAGE.O_SICARF_TITULO))
                    ]),
                    _c("img", {
                      staticClass: "redimensiona",
                      attrs: { src: require("@/assets/images/linha.png") }
                    })
                  ])
                ])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "sicarf margin-bottom-container" },
            [
              _c(
                "el-col",
                {
                  staticClass: "sicarf-col text-sicarf",
                  attrs: { md: 12, sm: 24 }
                },
                [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.HOME_PAGE.O_SICARF) }
                  }),
                  _c("p", {
                    staticClass: "descricaoSicarf",
                    domProps: {
                      innerHTML: _vm._s(_vm.HOME_PAGE.O_SICARF_DESCRICAO)
                    }
                  })
                ]
              ),
              _c(
                "el-col",
                { staticClass: "sicarf-col frame", attrs: { md: 12, sm: 24 } },
                [
                  _c("img", {
                    staticClass: "image-sicarf",
                    attrs: { src: _vm.HOME_PAGE.O_SICARF_DESCRICAO_IMG }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-row", { staticClass: "row-center margin-bottom-container" }, [
        _vm.HOME_PAGE.COMO_FUNCIONA
          ? _c("div", { staticClass: "padding-titulo" }, [
              _c("h1", { staticClass: "titulo-sicarf" }, [
                _vm._v("Veja como funciona!")
              ]),
              _c("img", {
                staticClass: "redimensiona",
                attrs: { src: require("@/assets/images/linha.png") }
              })
            ])
          : _vm._e(),
        _vm.VIDEOS_TUTORIAIS
          ? _c("div", [
              _c("div", { staticClass: "video-container center" }, [
                _c("div", { staticClass: "video-content" }, [
                  _c("iframe", {
                    staticClass: "default-iframe",
                    attrs: {
                      showinfo: "0",
                      width: "90%",
                      height: "350",
                      rel: "0",
                      src: _vm.VIDEOS_TUTORIAIS.APRESENTACAO,
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "allowfullscreen",
                      modestbranding: "1"
                    }
                  }),
                  _c("div", { staticClass: "video-span" }, [
                    _vm._v("Conheça o SiCARF")
                  ])
                ])
              ]),
              _c("div", { staticClass: "video-container" }, [
                _c("div", { staticClass: "video-content" }, [
                  _c("iframe", {
                    staticClass: "default-iframe",
                    attrs: {
                      showinfo: "0",
                      width: "90%",
                      height: "350",
                      rel: "0",
                      src: _vm.VIDEOS_TUTORIAIS.COMO_BAIXAR,
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "allowfullscreen",
                      modestbranding: "1"
                    }
                  }),
                  _c("div", { staticClass: "video-span" }, [
                    _vm._v("Como baixar")
                  ])
                ]),
                _c("div", { staticClass: "video-content" }, [
                  _c("iframe", {
                    staticClass: "default-iframe",
                    attrs: {
                      showinfo: "0",
                      width: "90%",
                      height: "350",
                      rel: "0",
                      src: _vm.VIDEOS_TUTORIAIS.COMO_ENVIAR,
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "allowfullscreen",
                      modestbranding: "1"
                    }
                  }),
                  _c("div", { staticClass: "video-span" }, [
                    _vm._v("Como enviar")
                  ])
                ])
              ]),
              _c("div", { staticClass: "video-container" }, [
                _c("div", { staticClass: "video-content" }, [
                  _c("iframe", {
                    staticClass: "default-iframe",
                    attrs: {
                      showinfo: "0",
                      width: "90%",
                      height: "350",
                      rel: "0",
                      src: _vm.VIDEOS_TUTORIAIS.MANUAL_USUARIO,
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "allowfullscreen",
                      modestbranding: "1"
                    }
                  }),
                  _c("div", { staticClass: "video-span" }, [
                    _vm._v("Manual do usuário")
                  ])
                ]),
                _c("div", { staticClass: "video-content" }, [
                  _c("iframe", {
                    staticClass: "default-iframe",
                    attrs: {
                      showinfo: "0",
                      width: "90%",
                      height: "350",
                      rel: "0",
                      src: _vm.VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF,
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "allowfullscreen",
                      modestbranding: "1"
                    }
                  }),
                  _c("div", { staticClass: "video-span" }, [
                    _vm._v("Manual do usuário")
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm.HOME_PAGE.COMO_FUNCIONA
          ? _c(
              "div",
              [
                _c("el-col", { attrs: { md: 8, sm: 24 } }, [
                  _c("img", {
                    staticClass: "imagem-sicarf-como-funciona",
                    style: {
                      "max-width": _vm.HOME_PAGE.COMO_FUNCIONA
                        .COMO_FUNCIONA_IMAGEM_1_HAS_WIDTH_E_HEIGHT_IGUAL
                        ? "210px"
                        : "305px",
                      height: _vm.HOME_PAGE.COMO_FUNCIONA
                        .COMO_FUNCIONA_IMAGEM_1_HAS_WIDTH_E_HEIGHT_IGUAL
                        ? "100%"
                        : "80%"
                    },
                    attrs: {
                      src: _vm.HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_1
                    }
                  }),
                  _c("p", {
                    staticClass: "padding texto-veja-como-funciona",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_1
                      )
                    }
                  })
                ]),
                _c("el-col", { attrs: { md: 8, sm: 24 } }, [
                  _c("img", {
                    staticClass: "imagem-sicarf-como-funciona",
                    style: {
                      "max-width": _vm.HOME_PAGE.COMO_FUNCIONA
                        .COMO_FUNCIONA_IMAGEM_2_HAS_WIDTH_E_HEIGHT_IGUAL
                        ? "210px"
                        : "305px",
                      height: _vm.HOME_PAGE.COMO_FUNCIONA
                        .COMO_FUNCIONA_IMAGEM_2_HAS_WIDTH_E_HEIGHT_IGUAL
                        ? "100%"
                        : "80%"
                    },
                    attrs: {
                      src: _vm.HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_2
                    }
                  }),
                  _c("p", {
                    staticClass: "padding texto-veja-como-funciona",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_2
                      )
                    }
                  })
                ]),
                _c("el-col", { attrs: { md: 8, sm: 24 } }, [
                  _c("img", {
                    staticClass: "imagem-sicarf-como-funciona",
                    style: {
                      "max-width": _vm.HOME_PAGE.COMO_FUNCIONA
                        .COMO_FUNCIONA_IMAGEM_3_HAS_WIDTH_E_HEIGHT_IGUAL
                        ? "210px"
                        : "305px",
                      height: _vm.HOME_PAGE.COMO_FUNCIONA
                        .COMO_FUNCIONA_IMAGEM_3_HAS_WIDTH_E_HEIGHT_IGUAL
                        ? "100%"
                        : "80%"
                    },
                    attrs: {
                      src: _vm.HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_3
                    }
                  }),
                  _c("p", {
                    staticClass: "padding texto-veja-como-funciona",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_3
                      )
                    }
                  })
                ])
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.HOME_PAGE.EXIBIR_GALERIA
        ? _c(
            "el-row",
            { staticClass: "margin-bottom-container" },
            [_c("the-gallery")],
            1
          )
        : _vm._e(),
      _vm.HOME_PAGE.EXIBIR_COMENTARIOS
        ? _c(
            "el-row",
            { staticClass: "row-center margin-bottom-container" },
            [
              _c("h1", { staticClass: "titulo-sicarf" }, [
                _vm._v("Depoimentos sobre nós")
              ]),
              _c("img", {
                staticClass: "redimensiona",
                attrs: { src: require("@/assets/images/linha.png") }
              }),
              _c("the-comments")
            ],
            1
          )
        : _vm._e(),
      _c("el-row", { staticClass: "row-center margin-bottom-container" }, [
        _c("div", { staticClass: "padding-titulo" }, [
          _c("h1", { staticClass: "titulo-sicarf" }, [
            _vm._v("Entre em contato")
          ]),
          _c("img", {
            staticClass: "redimensiona",
            attrs: { src: require("@/assets/images/linha.png") }
          })
        ]),
        _c(
          "div",
          [
            _c(
              "el-col",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "flex-direction": "column"
                },
                attrs: {
                  md: _vm.HOME_PAGE.ENTRE_EM_CONTATO.EXIBIR_FORMULARIO
                    ? 12
                    : 24,
                  sm: 24
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "padding-entrar-contato",
                    style: {
                      width: _vm.HOME_PAGE.ENTRE_EM_CONTATO.EXIBIR_FORMULARIO
                        ? "100%"
                        : "90%"
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("el-row", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.HOME_PAGE.ENTRE_EM_CONTATO.SOBRE))
                          ])
                        ])
                      ],
                      1
                    ),
                    _c("br"),
                    _c(
                      "div",
                      {
                        staticClass: "alinhamento-texto-entrar-contato",
                        staticStyle: { width: "100%" }
                      },
                      [
                        _c(
                          "el-row",
                          {
                            class: !_vm.HOME_PAGE.ENTRE_EM_CONTATO
                              .EXIBIR_FORMULARIO
                              ? "cards-sicarf"
                              : "",
                            staticStyle: { width: "100%" }
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "icones-entrar-contato",
                              attrs: { icon: "address-card" }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.HOME_PAGE.ENTRE_EM_CONTATO.ENDERECO)
                              )
                            ])
                          ],
                          1
                        ),
                        _c("br"),
                        _c(
                          "div",
                          {
                            class: !_vm.HOME_PAGE.ENTRE_EM_CONTATO
                              .EXIBIR_FORMULARIO
                              ? "row-divider-child"
                              : "",
                            staticStyle: { width: "100%" }
                          },
                          [
                            _c(
                              "el-row",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "icones-entrar-contato",
                                  attrs: { icon: "building" }
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.HOME_PAGE.ENTRE_EM_CONTATO.TELEFONE
                                    )
                                  )
                                ])
                              ],
                              1
                            ),
                            _c("br"),
                            _vm.HOME_PAGE.ENTRE_EM_CONTATO.SUPORTE
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "icones-entrar-contato",
                                          attrs: { icon: "phone-square" }
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.HOME_PAGE.ENTRE_EM_CONTATO
                                                .SUPORTE
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _c("br")
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-row",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "icones-entrar-contato",
                                  attrs: { icon: "globe-americas" }
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.HOME_PAGE.ENTRE_EM_CONTATO.SITE)
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm.HOME_PAGE.ENTRE_EM_CONTATO.HORARIO_FUNCIONAMENTO
                              ? _c(
                                  "div",
                                  [
                                    _c("br"),
                                    _c(
                                      "el-row",
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "icones-entrar-contato",
                                          attrs: { icon: "clock" }
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.HOME_PAGE.ENTRE_EM_CONTATO
                                                .HORARIO_FUNCIONAMENTO
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm.HOME_PAGE.ENTRE_EM_CONTATO.EXIBIR_FORMULARIO
              ? _c(
                  "el-col",
                  {
                    staticClass:
                      "padding-entrar-contato padding-botom-entrar-contato",
                    attrs: { md: 12, sm: 24 }
                  },
                  [
                    _c(
                      "validation-observer",
                      {
                        ref: "validation",
                        staticClass: "container-enviar-email",
                        attrs: { tag: "div" }
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("el-input", {
                                          staticClass:
                                            "input margin-top-input-nome",
                                          class: {
                                            erro:
                                              errors.length &&
                                              !_vm.solicitacaoRealizada
                                          },
                                          attrs: {
                                            name: "nome",
                                            "data-vv-scope": "funcaoEmail",
                                            placeholder: "Nome"
                                          },
                                          model: {
                                            value: _vm.contato.nome,
                                            callback: function($$v) {
                                              _vm.$set(_vm.contato, "nome", $$v)
                                            },
                                            expression: "contato.nome"
                                          }
                                        }),
                                        !_vm.solicitacaoRealizada
                                          ? _c(
                                              "p",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4131808762
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("el-input", {
                                          staticClass: "input",
                                          class: {
                                            erro:
                                              (errors.length &&
                                                !_vm.solicitacaoRealizada) ||
                                              !_vm.emailValido
                                          },
                                          attrs: {
                                            name: "email",
                                            placeholder: "Email",
                                            "data-vv-scope": "funcaoEmail"
                                          },
                                          on: { change: _vm.isEmailValid },
                                          model: {
                                            value: _vm.contato.email,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.contato,
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression: "contato.email"
                                          }
                                        }),
                                        !_vm.emailValido
                                          ? _c(
                                              "span",
                                              { staticClass: "help erro" },
                                              [_vm._v("Email inválido.")]
                                            )
                                          : _vm._e(),
                                        !_vm.solicitacaoRealizada
                                          ? _c(
                                              "p",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                391144629
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: [
                                                "(##) ####-####",
                                                "(##) #####-####"
                                              ],
                                              expression:
                                                "['(##) ####-####', '(##) #####-####']"
                                            }
                                          ],
                                          staticClass: "input",
                                          class: {
                                            erro:
                                              errors.length &&
                                              !_vm.solicitacaoRealizada
                                          },
                                          attrs: {
                                            name: "telefone",
                                            maxlength: 15,
                                            "data-vv-scope": "funcaoEmail",
                                            placeholder: "Telefone"
                                          },
                                          model: {
                                            value: _vm.contato.telefone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.contato,
                                                "telefone",
                                                $$v
                                              )
                                            },
                                            expression: "contato.telefone"
                                          }
                                        }),
                                        !_vm.solicitacaoRealizada
                                          ? _c(
                                              "p",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1939319917
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("el-input", {
                                          staticClass: "input",
                                          class: {
                                            erro:
                                              errors.length &&
                                              !_vm.solicitacaoRealizada
                                          },
                                          attrs: {
                                            type: "textarea",
                                            placeholder: "Digite o texto...",
                                            name: "texto",
                                            "data-vv-scope": "funcaoEmail",
                                            maxlength: "500"
                                          },
                                          model: {
                                            value: _vm.contato.texto,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.contato,
                                                "texto",
                                                $$v
                                              )
                                            },
                                            expression: "contato.texto"
                                          }
                                        }),
                                        !_vm.solicitacaoRealizada
                                          ? _c(
                                              "p",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1326981530
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "button" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: {
                                  type: "success",
                                  loading: _vm.loading
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.enviarEmailEntrarEmContato()
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _c(
                                    "b",
                                    [
                                      _vm._v("Enviar  "),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "paper-plane" }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc758a52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc758a52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/home/TheSicarf.vue
// module id = null
// module chunks = 